WL.registerComponent('wall-visibility', {
  visualBlocker: {type: WL.Type.Object}
}, {
    init: function() {
        this.block = this.visualBlocker.getComponent('mesh');
        this.rigidBody = this.object.getComponent('physx');
    },
    update: function() {
      this.rigidBody.onCollision(function(type, other) {
        if(type == 1){
          if(this.block.active) this.block.active = false;
          return;
        }
        if(other){
          if(!this.block.active) this.block.active = true;
        }
      }.bind(this));
    }
});
